import { useStageConfig } from "in_queue/contexts/ClusterContext";
import { useSpeculativeProjectsInCluster } from "in_queue/contexts/ProjectDataContext";
import { SectionHeader } from "../common/SectionHeader";
import { SpeculativeProjectsTable } from "../tables/SpeculativeProjectsTable";
import { CreateSpeculativeProjectButton } from "./CreateSpeculativeProject/CreateSpeculativeProject";
import css from "./SpeculativeProjectsSection.module.scss";

export const SpeculativeProjectsSection = () => {
    const speculativeProjects = useSpeculativeProjectsInCluster();
    const { enableSpeculativeProjects } = useStageConfig();

    return enableSpeculativeProjects ? (
        <div className={css["speculative-projects"]}>
            <SectionHeader
                level="h2"
                title="Study Projects"
                actions={<CreateSpeculativeProjectButton />}
            />
            <SpeculativeProjectsTable
                projects={speculativeProjects}
                height="auto"
            />
        </div>
    ) : null;
};
